import {Col, Row} from "antd";
import {SessionGenInfoSessionCallDurationFormField} from "./call-duration-form-field";
import {SessionGenInfoSessionCustomCallDurationFormField} from "./custom-call-duration-form-field";
import {SessionGenInfoSessionDurationFormFieldProps} from "./types";

export function SessionGenInfoSessionDurationFormField({
  callDurationFormFieldId,
  callDurationFormFieldLabel,
  callDurationFormFieldPlaceholder,
  customCallDurationFormFieldId,
  customCallDurationFormFieldLabel,
  customCallDurationFormFieldPlaceholder,
}: SessionGenInfoSessionDurationFormFieldProps) {
  return (
    <Row gutter={[16, 16]}>
      <Col span={24} sm={12}>
        <SessionGenInfoSessionCallDurationFormField
          id={callDurationFormFieldId}
          label={callDurationFormFieldLabel}
          placeholder={callDurationFormFieldPlaceholder}
        />
      </Col>
      <Col span={24} sm={12}>
        <SessionGenInfoSessionCustomCallDurationFormField
          id={customCallDurationFormFieldId}
          label={customCallDurationFormFieldLabel}
          placeholder={customCallDurationFormFieldPlaceholder}
        />
      </Col>
    </Row>
  );
}
